import { useTranslation } from "react-i18next";

const useListColumns = () => {
  const { t } = useTranslation(["core"]);

  return [
    {
      Header: t("core:common.order"),
      accessor: "order",
      disableGlobalFilter: true,
      width: 65,
    },
    {
      Header: t("core:common.name"),
      accessor: "name",
    },
    {
      Header: t("core:common.date"),
      accessor: "releaseDate",
      disableGlobalFilter: true,
    },
    {
      Header: t("core:common.edition"),
      accessor: "edition",
      disableGlobalFilter: true,
    },
    {
      Header: t("core:common.price"),
      accessor: "price",
      disableGlobalFilter: true,
    },
    {
      Header: t("core:common.state"),
      accessor: "state",
      disableGlobalFilter: true,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
